class BizApiErrorInterpreter {
    constructor(getter) {
        this.getter = getter;
    }

    isError = (response) => {
        return this.getter.safeGet(() => response.is_error, false);
    }

    getErrorCode = (response) => {
        return this.getter.safeGet(() => response.code, "");
    }

    getErrorContextCode = (response) => {
        return this.getter.safeGet(() => response.context_code, "");
    }
}

export default BizApiErrorInterpreter;